export const skipMethod = (window as any)['SKIP_METHOD'] === 'true'
